import issuesService from "src/services/issuesService";

export const FETCH_ISSUES = '@business/fetch-issues';
export const FETCH_ISSUES_SUCCESS = '@business/fetch-issues-success';
export const FETCH_ISSUES_FAILURE = '@business/fetch-issues-failure';

export const FETCH_ISSUE = '@business/fetch-issue';
export const FETCH_ISSUE_SUCCESS = '@business/fetch-issue-success';
export const FETCH_ISSUE_FAILURE = '@business/fetch-issue-failure';

export const FETCH_ISSUES_RESOULUTION_TYPE = '@business/fetch-issues-resolution-type';
export const FETCH_ISSUES_RESOULUTION_TYPE_SUCCESS = '@business/fetch-issues-resolution-type-success';
export const FETCH_ISSUES_RESOULUTION_TYPE_FAILURE = '@business/fetch-issues-resolution-type-failure';

export const FETCH_ISSUES_ACTION_TYPES = '@business/fetch-issues-action-types';
export const FETCH_ISSUES_ACTION_TYPES_SUCCESS = '@business/fetch-issues-action-types-success';
export const FETCH_ISSUES_ACTION_TYPES_FAILURE = '@business/fetch-issues-action-types-failure';

export const FETCH_ONDC_SERVER_TYPES = '@business/fetch-ondc-server-types';
export const FETCH_ONDC_SERVER_TYPES_SUCCESS = '@business/fetch-ondc-server-types-success';
export const FETCH_ONDC_SERVER_TYPES_FAILURE = '@business/fetch-ondc-server-types-failure';


export const ISSUES_UPDATE = '@business/update-issues';
export const ISSUES_UPDATE_SUCCESS = '@business/update-issues-success';
export const ISSUES_UPDATE_FAILURE = '@business/update-issues-failure';

export const ISSUES_CREATE = '@business/create-issues';
export const ISSUES_CREATE_SUCCESS = '@business/create-issues-success';
export const ISSUES_CREATE_FAILURE = '@business/create-issues-failure';

export const FETCH_ISSUE_INFO_TYPES = '@business/fetch-issue-info-types';
export const FETCH_ISSUE_INFO_TYPES_SUCCESS = '@business/fetch-issue-info-types-success';
export const FETCH_ISSUE_INFO_TYPES_FAILURE = '@business/fetch-issue-info-types-failure';


export function fetchIssues(customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCH_ISSUES });
            const issues = await issuesService.fetchIssues(customerId);
            dispatch({
                type: FETCH_ISSUES_SUCCESS,
                payload: {
                    issues
                },
            });
            return issues;
        } catch (error) {
            dispatch({ type: FETCH_ISSUES_FAILURE });
            throw error;
        }
    };
}

export function fetchIssue(customerId, issueId) {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCH_ISSUE });
            const resp = await issuesService.fetchIssue(customerId, issueId);
            console.log("fetchIssue(A) : ", resp);
            dispatch({
                type: FETCH_ISSUE_SUCCESS,
                payload: {
                    issueDetails: resp
                },
            });
            return resp;
        } catch (error) {
            dispatch({ type: FETCH_ISSUE_FAILURE });
            throw error;
        }
    };
}

export function fetchIssuesResolutionTypes() {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCH_ISSUES_RESOULUTION_TYPE });
            const resp = await issuesService.fetchIssuesResolutionTypes();
            console.log("fetchIssuesResolutionTypes() ", resp);
            dispatch({
                type: FETCH_ISSUES_RESOULUTION_TYPE_SUCCESS,
                payload: {
                    resolutionTypes: resp
                },
            });
            return resp;
        } catch (error) {
            dispatch({ type: FETCH_ISSUES_RESOULUTION_TYPE_FAILURE });
            throw error;
        }
    };
}

export function fetchIssuesActionTypes() {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCH_ISSUES_ACTION_TYPES });
            const resp = await issuesService.fetchIssuesActionTypes();
            console.log("fetchIssuesActionTypes() ", resp);
            dispatch({
                type: FETCH_ISSUES_ACTION_TYPES_SUCCESS,
                payload: {
                    actionTypes: resp
                },
            });
            return resp;
        } catch (error) {
            dispatch({ type: FETCH_ISSUES_ACTION_TYPES_FAILURE });
            throw error;
        }
    };
}

export function fetchIssuesInfoTypes() {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCH_ISSUE_INFO_TYPES });
            const resp = await issuesService.fetchIssuesInfoTypes();
            console.log("fetchIssuesInfoTypes() ", resp);
            dispatch({
                type: FETCH_ISSUE_INFO_TYPES_SUCCESS,
                payload: {
                    actionTypes: resp
                },
            });
            return resp;
        } catch (error) {
            dispatch({ type: FETCH_ISSUE_INFO_TYPES_FAILURE });
            throw error;
        }
    };
}

export function updateIssuesAction(values) {
    return async (dispatch) => {
        try {
            const payload = {
                customerId: values?.customerId,
                serverType: values?.serverType,
                issueId: values?.issueId,
                resolutions: values?.resolutionType,
                action: values?.actionType,
                comment: values?.remarks,
                info: values?.infoType
            }

            
            dispatch({ type: ISSUES_UPDATE });            
            const resp = await issuesService.updateIssuesAction(payload);
            console.log("updateIssuesAction() ", resp);
            dispatch({
                type: ISSUES_UPDATE_SUCCESS,
                payload: {
                    status: resp
                },
            });
        } catch (error) {
            dispatch({ type: ISSUES_UPDATE_FAILURE });
            throw error;
        }
    };
}

export function createONDCIssueAction(formData, preferredServerType) {
    return async (dispatch) => {
        try {
            // const payload = {
            //     customerId: values?.customerId,
            //     ondcOrderId: values?.ondcOrderId,
            //     expectedResponseTime: values?.expectedResponseTime,
            //     expectedResolutionTime: values?.expectedResolutionTime,
            //     level: values?.level,
            //     descriptionShort: values?.descriptionShort,
            //     descriptionLong: values?.descriptionLong,
            // }
            
            dispatch({ type: ISSUES_CREATE });            
            const resp = await issuesService.createONDCIssues(formData, preferredServerType);
            console.log("updateIssuesAction() ", resp);
            dispatch({
                type: ISSUES_CREATE_SUCCESS,
                payload: {
                    status: resp
                },
            });
        } catch (error) {
            dispatch({ type: ISSUES_CREATE_FAILURE });
            throw error;
        }
    };
}


export function fetchONDCServerType() {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCH_ONDC_SERVER_TYPES });
            const resp = await issuesService.fetchONDCServerType();
            console.log("fetchONDCServerType() ", resp);
            dispatch({
                type: FETCH_ONDC_SERVER_TYPES_SUCCESS,
                payload: {
                    actionTypes: resp
                },
            });
            return resp;
        } catch (error) {
            dispatch({ type: FETCH_ONDC_SERVER_TYPES_FAILURE });
            throw error;
        }
    };
}